/**
 * Bekleme (hata DEĞİL) durumlarının TEK metin kaynağı (v3.3, PM § 5; sözleşme: `provider-status.ts` `PROVIDER_WAITS`). Bağlantılar
 * ekranındaki bağlama bildirimi ve harcama ekranındaki eşitleme rozeti aynı sözü söyler: bağlantı "Bağlı" kalır, okuma hakkı
 * yer açılınca kendiliğinden sürer. Yaprak modüldür (başka metin dosyasını içe aktarmaz): döngüsüz paylaşılır.
 */
import type { ProviderWait } from '@castinflow/shared';

export const providerWaitText = {
  read_budget: 'Okuma hakkı bekleniyor',
} as const satisfies Record<ProviderWait, string>;
